import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SignupCompletedModule } from '../components/signup-completed/singup-completed.module';
import { SignupInviteComponent } from './invite.component';

@NgModule({
    imports: [CommonModule, SignupCompletedModule],
    declarations: [SignupInviteComponent],
    exports: [SignupInviteComponent]
})
export class SignupInviteModule {}
